<template>
  <div style="width: 100%">
    <!-- <el-divider class="divider"></el-divider> -->
    <el-form
      ref="form"
      :model="form"
      size="mini"
      class="panel"
      label-width="80px"
    >
      <el-form-item label="组件类型">
        <el-select
          size="mini"
          style="width: 100%"
          v-model="form.uiType"
          placeholder="请选择类型"
          disabled
        >
          <el-option
            v-for="item in list"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="名称">
        <el-input
          size="mini"
          v-model="form.name"
          @change="getFormChange"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="选取列表"
        v-if="form.uiType === 3 || form.uiType === 4"
      >
        <div style="display: flex; gap: 6px">
          <el-select
            filterable
            size="mini"
            style="width: 100%"
            v-model="form.listValue"
            placeholder="请选择类型"
            @change="getFormChange"
          >
            <el-option
              v-for="item in listArray"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <!-- <el-button type="primary" icon="el-icon-search"></el-button> -->
        </div>
      </el-form-item>
      <!-- <el-form-item label="宽度">
        <el-input
          size="mini"
          v-model="form.width"
          @change="getFormChange"
        ></el-input>
      </el-form-item> -->

      <el-form-item label="是否必填">
        <el-switch v-model="form.required" @change="getFormChange"></el-switch>
      </el-form-item>
      <!-- <el-form-item label="能否搜索">
      <el-switch v-model="form.search"></el-switch>
    </el-form-item> -->
      <!-- <el-form-item label="能否清空">
        <el-switch v-model="form.clearable"></el-switch>
      </el-form-item> -->
      <!-- <el-form-item label="能否禁用">
        <el-switch v-model="form.enabled"></el-switch>
      </el-form-item> -->
    </el-form>
  </div>
</template>
<script>
import axios from "axios";
import { upDateAttriAPI } from "./configAPI";

export default {
  data() {
    return {
      list: [
        { label: "单行文本", value: 1 },
        { label: "多行文本", value: 2 },
        { label: "单选列表", value: 3 },
        { label: "多选列表", value: 4 },
        { label: "日期组件", value: 6 },
        { label: "数字文本", value: 7 },
      ],
      listArray: [],
      form: {
        name: "",
        uiType: "",
        required: false,
        clearable: "",
        enabled: false,
        listValue: "",
        width: "120",
      },
    };
  },
  props: {
    panelItem: {
      type: Object,
    },
  },
  mounted() {
    this.getData();
    // console.log(12312);
  },
  methods: {
    getFormChange(val) {
      this.$emit("edit", this.form);
    },

    async getData() {
      console.log(this.panelItem);

      const { uiType, label, name, required, listValue } = this.panelItem;
      this.form = {
        ...this.form,
        uiType,
        name: label || name,
        required: !!required,
        listValue: listValue == -1 ? '' : +listValue
      };

      if (uiType === 3 || uiType === 4) {
        const { data } = await axios.get(`/pmdm/admin/list/getAll`);
        this.listArray = data.object.listEntities.map((i) => {
          const { name: label, id: value } = i;
          return { label, value };
        });
      }
    },
    onSubmit() {
      console.log("submit!");
    },
  },
};
</script>
<style lang="scss" scoped>
.divider {
  margin: 6px 0;
}
</style>
<style lang="scss">
.panel {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;

  .el-form-item {
    width: 48%;
    margin-bottom: 2px;
  }

  .el-form-item__label {
    font-size: 12px;
    color: #09090b;
  }
}
</style>